import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import If from 'global/ErrorHandlers/If';
import Image from 'global/Image';
import { Input } from '../styled';
import FormTooltip from './FormTooltip';
import {
  InputFormWrapper,
  InputContainer,
  TextWarningContainer,
} from './styled';

interface InputFormProps {
  isChecked: any;
  errorMsg: string;
  type: string;
  placeholder?: string;
  disabled?: boolean;
  hint?: {
    title: string;
    description: string;
  };
  toggleButton?: React.ReactNode | null;
  [key: string]: any;
}

const defaultHint = {
  title: '',
  description: '',
};

function InputForm({
  isChecked,
  errorMsg,
  placeholder,
  disabled = false,
  type,
  hint = defaultHint,
  toggleButton = null,
  ...otherProps
}: InputFormProps) {
  return (
    <InputFormWrapper disabled={disabled}>
      <FormTooltip {...hint}>
        <InputContainer
          mt="25px"
          pr="40px"
          activeColorBar={errorMsg ? color.sunsetOrange : color.primary}
          error={errorMsg}
          isPassword={!!toggleButton}
        >
          <Input
            required
            placeholder={placeholder}
            disabled={disabled}
            type={type}
            {...otherProps}
          />
        </InputContainer>

        <If condition={toggleButton}>{toggleButton}</If>

        <If condition={errorMsg && isChecked}>
          <TextWarningContainer>
            <Image
              src="/icon/register/input-warning.svg"
              height="18px"
              width="18px"
            />
            <Text
              size="12px"
              color={color.sunsetOrange}
              data-cy="register-error-message"
            >
              {errorMsg}
            </Text>
          </TextWarningContainer>
        </If>
      </FormTooltip>
    </InputFormWrapper>
  );
}

export default InputForm;
